import { createSelector } from 'reselect';
import NotificationCollection from '../../models/NotificationCollection';

const getNotifications = state => state.global.notifications;

export const getNotificationsState = createSelector(
  [getNotifications],
  notifications => new NotificationCollection(notifications),
);
